import { AccountBankingTypeView, AccountView } from '../../../types/entity-types';
import { isBankingAccount } from '../../../utils/accounts/is-banking-account';
import { getSyncStatusText } from '../../../utils/get-sync-status-text';

export type LastSyncData = {
  text: string;
  lastSyncAttemptAt: Date | null;
  account?: {
    id: string;
    name?: string;
  };
} | null;

export const getTimeSinceLastSyncFromAccount = (account: AccountBankingTypeView): LastSyncData => {
  const syncText = getSyncStatusText({
    status: account.syncResult.syncStatus,
    lastSyncAttemptAt: account.syncResult.lastSyncAttemptAt,
    nextSyncAt: account.syncResult.nextSyncAt,
  });

  if (!syncText) {
    return null;
  }

  return {
    text: syncText,
    lastSyncAttemptAt: account.syncResult.lastSyncAttemptAt || null,
    account: {
      id: account.id,
      name: account.name,
    },
  };
};

export const getTimeSinceLastSyncFromAccounts = (accounts: AccountView[]): LastSyncData => {
  if (accounts.length === 0) {
    return null;
  }

  const bankingAccounts = accounts.filter(isBankingAccount);

  // Find account with most recent sync
  const mostRecentAccount = bankingAccounts.reduce((mostRecent, current) => {
    if (!current.syncResult.lastSyncAttemptAt) {
      return mostRecent;
    }
    if (!mostRecent || !mostRecent.syncResult.lastSyncAttemptAt) {
      return current;
    }
    return current.syncResult.lastSyncAttemptAt > mostRecent.syncResult.lastSyncAttemptAt ? current : mostRecent;
  }, bankingAccounts[0]);

  return getTimeSinceLastSyncFromAccount(mostRecentAccount);
};
